import zh from 'element-ui/lib/locale/lang/zh-CN'
import en from 'element-ui/lib/locale/lang/en'

const elementLangs = {
  zh,
  en
}

export default elementLangs
